
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TrainingClassApi } from '../api/trainingclass.api';
import { switchMap, map } from 'rxjs/operators';

import { TrainingClassData, TrainingClass } from '../../../interfaces/masters/trainingclass' ;
@Injectable()
export class TrainingClassService extends TrainingClassData {

    constructor(private api: TrainingClassApi) {
      super();
    }
  
  
    list(url: string): Observable<TrainingClass[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<TrainingClass>{
        return this.api.getById(url);
    }
  
    create(url: string, data:TrainingClass): Observable<TrainingClass[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:TrainingClass): Observable<TrainingClass> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  